import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Row, Col, CardBody, Card, Container, Form, Input, Label, FormFeedback, Alert } from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import SM_LOGO from 'assets/images/logo/logo-small.png'
import withRouter from "Components/withRouter";
import { login } from "helpers/API Calls/Auth and Profile/auth";


const Login = (props: any) => {
  // document.title = "Login | Castle Hire";
  const navigate = useNavigate(); 
  
  const [show, setShow] = useState<boolean>(false);
  const [error, setError] = useState<string | null> (null);

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: Yup.object({
      email: Yup.string()
      .email("Please enter a valid email address")
      .required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);
      setError(null);
      const response = await login(values);
      if(response.success){
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        navigate('/')
      }else{
        setError(response.message);
      }
      setSubmitting(false);
    }
  });

  useEffect(() => {
    if (error) {setTimeout(() => { setError(null);}, 5000);}
  }, [error])

  return (
    <React.Fragment>
      <div className="account-pages vh-100">
        <Container className="vh-100">
          <Row className="justify-content-center h-100 align-items-center w-100">
            <Col xl={4} md={8} lg={6} className="my-auto">
              <Card>
                <div className="auth-avatar-container">
                  <div className="auth-logo">
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={SM_LOGO}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                </div>
                <CardBody className="py-5">
                  <h2 className="fw-bold">Sign-in to get started!</h2>
                  <div className="p-2">
                    <Form className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="mb-3">
                        {error ? <Alert color="danger">{error}</Alert> : null}
                        <Label className="form-label">Email</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email ? true : false
                          }
                          autoComplete="username"
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                        ) : null}
                      </div>


                      <div className="mb-3">
                        <Label className="form-label">Password</Label>
                        <div className="input-group auth-pass-inputgroup">
                          <Input
                            name="password"
                            value={validation.values.password || ""}
                            type={show ? "text" : "password"}
                            placeholder="Enter Password"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched.password && validation.errors.password ? true : false
                            }
                            autoComplete="current-password"
                          />
                          <button onClick={() => setShow(!show)} className="btn btn-light " type="button" id="password-addon"><i className="mdi mdi-eye-outline"></i></button>
                          {validation.touched.password && validation.errors.password ? (
                            <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                          ) : null}
                        </div>
                      </div>


                      <div className="mt-4 d-grid">
                        <button className="btn btn-primary btn-block " type="submit" disabled={validation.isSubmitting}>{validation.isSubmitting ? 'Submitting...' : "Log In"}</button>
                      </div>
                    </Form>
                    <div className="mt-4 text-center">
                      <Link to="/forgot-password" className="text-muted">
                        <i className="mdi mdi-lock me-1" /> Forgot your
                        password?
                      </Link>
                    </div>
                  </div>
                  
                  
                </CardBody>
              </Card>
              
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);
